import { Pipe, PipeTransform, Injectable } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({
    name: 'utcToLocalTime',
    standalone: false
})
@Injectable()
export class UtcToLocalTimePipe implements PipeTransform {

  /**
   * Convierte una fecha UTC al horario local del usuario
   * @param utcDateTime - Fecha en formato UTC (ISO string)
   * @param format - Formato de salida (por defecto mantiene formato original)
   * @param timezone - Timezone específico (opcional, si no se proporciona usa el del navegador)
   * @returns string con la fecha en formato local
   */
  transform(utcDateTime: string | Date, format?: string, timezone?: string): string {
    if (!utcDateTime) {
      return '';
    }

    try {
      // Convertir a DateTime de Luxon
      let dateTime: DateTime;
      
      if (typeof utcDateTime === 'string') {
        // Si es string, asumir que viene en UTC
        dateTime = DateTime.fromISO(utcDateTime, { zone: 'utc' });
        if (!dateTime.isValid) {
          // El backend también entrega formato SQL ("2026-06-03 14:58:03"), que fromISO no acepta
          dateTime = DateTime.fromSQL(utcDateTime, { zone: 'utc' });
        }
      } else {
        // Si es Date object
        dateTime = DateTime.fromJSDate(utcDateTime, { zone: 'utc' });
      }

      // Verificar que la fecha es válida
      if (!dateTime.isValid) {
        console.warn('Fecha inválida recibida:', utcDateTime, dateTime.invalidReason);
        return '';
      }

      // Convertir al timezone local
      const localDateTime = timezone 
        ? dateTime.setZone(timezone) 
        : dateTime.setZone('local'); // Usa el timezone del navegador

      // Formatear y retornar
      // Si no se especifica formato, mantener el formato original
      if (!format) {
        return localDateTime.toISO();
      }
      return localDateTime.toFormat(format);
    } catch (error) {
      console.error('Error al convertir fecha UTC a local:', error, { utcDateTime, format, timezone });
      return '';
    }
  }
}
